import axios from 'axios';
import { attachAuth } from '@/utils/authSession';

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || "http://localhost:9000/",
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  }
});

attachAuth(apiClient);

export default {
    logger(event){
        return apiClient.post(`/collect/log`, event)
    }, 
    getCrsf(){
        return apiClient.get('/crsf')
    }
}